import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy Data Sharing URL. The panel moved under Subsidiary Settings
 * (`/subsidiary/data-sharing`); this keeps old bookmarks working.
 */
export const Route = createFileRoute('/_authenticated/_tenant/integrations_/sharing')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/subsidiary/data-sharing', replace: true });
  },
});
